<template>
    <v-card>
        <v-toolbar flat color="primary" class="white--text">
            <v-toolbar-title>Team List</v-toolbar-title>
        </v-toolbar>
        <v-layout wrap>
            <v-flex xs12 sm2 offset-sm4>
                <v-autocomplete
                    label="Work Types"
                    :items="$Constants.WORK_TYPES_ARRAY"
                    item-value="WorkTypeID"
                    item-text="Name"
                    v-model="filterWorkTypeID"
                >
                </v-autocomplete>
            </v-flex>
            <v-flex xs12 sm2>
                <v-checkbox
                    v-model="filterIsActive"
                    label="Active Only"
                >
                </v-checkbox>
            </v-flex>
            <v-flex xs12 sm2>
                <v-btn 
                    color="primary" 
                    block 
                    @click="openEdit()">
                    <span>Add</span>
                </v-btn>
            </v-flex>
        </v-layout>
        <v-layout pt-3>
            <v-flex xs12>
                <v-data-table
                    :headers="headers"
                    hide-actions
                    :loading="loading"
                    :items="dataFiltered">
                    <template v-slot:items="{ item }">
                        <td>{{ item.Name }}</td>
                        <td>{{ item.WorkTypeName }}</td>
                        <td>
                            <v-checkbox
                                class="grid-checkbox"
                                :input-value="item.IsActive"
                                disabled
                            >
                            </v-checkbox>
                        </td>
                        <td>
                            <v-btn 
                                color="primary"
                                block 
                                @click="openEdit(item)">
                                <span>Edit</span>
                            </v-btn>
                        </td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-card>
</template>

<script>
export default {
    props: {
        data: {
            required: true,
            value: Array
        },
        loading: {
            required: true,
            value: Boolean
        }
    },
    data() {
        return {
            filterIsActive: true,
            filterWorkTypeID: -1,
            headers: [
                {
                    text: "Name",
                    value: "Name",
                    sortable: true
                },
                {
                    text: "Work Type",
                    value: "WorkTypeID"
                },
                {
                    text: "Active",
                    value: "IsActive",
                    sortable: true
                },
                {
                    text: "Edit",
                    value: "",
                    sortable: false
                }
            ]
        }
    },
    computed: {
        dataFiltered() {
            var that = this;

            return this.data.filter(function(item) {
                var include = !that.filterIsActive || item.IsActive;

                // don't bother with the next filter if this one fails
                if (!include) {
                    return false;
                }

                include = that.filterWorkTypeID <= 0 || item.WorkTypeID == that.filterWorkTypeID;

                return include;
            });
        }
    },
    methods: {
        openEdit(item) {
            this.$emit("edit", item);
        }
    }
}
</script>

<style>
/* I don't know why Vuetify's checkboxes are surrounded by nonsense, but they are - this is an attempt to get them to sit near the middle (vertically) of the row in the grid */
#app .grid-checkbox {
    max-height: 25px;
}
</style>